import { Table } from 'shared/components'

export const createColumnsHistory = () => [
  {
    Header: 'Type',
    accessor: 'type',
    maxWidth: 200,
    width: 200,
  },
  {
    Header: 'Time',
    accessor: 'time',
    Cell: Table.CellRenderers.DateTimeCell,
    minWidth: 400,
    width: 400,
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    minWidth: 220,
    width: 220,
  },
  {
    Header: 'currency',
    accessor: 'invoicePaymentInformation.invoice.currentState',
    minWidth: 220,
    width: 220,
  },
  {
    Header: 'Invoice number',
    accessor: 'invoicePaymentInformation.invoice.number',
    minWidth: 320,
    width: 320,
  },
  {
    Header: 'Invoice creation',
    accessor: 'invoicePaymentInformation.invoice.creationDate',
    Cell: Table.CellRenderers.DateTimeCell,
    maxWidth: 340,
    width: 340,
  },
  {
    Header: 'Payed status',
    accessor: 'invoicePaymentInformation.invoice.currentState',
    minWidth: 500,
    width: 500,
  },
]
